import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function Problem() {
  const problems = ['te dejan con hambre', 'te quitan todo lo rico', 'te hacen bajar y luego rebotar', 'te complican la vida social', 'te hacen sentir culpa cada vez que sales a comer'];
  return <section className="py-20 bg-white" data-id="element-140">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <FadeIn data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-warm-brown mb-12" data-id="element-143">
            Si ya intentaste dietas que...
          </h2>
        </FadeIn>

        <div className="bg-warm-beige/30 rounded-3xl p-8 md:p-12 shadow-sm border border-warm-beige" data-id="element-144">
          <div className="space-y-6 mb-12" data-id="element-145">
            {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-146">
                <div className="flex items-start" data-id="element-147">
                  <XCircle className="text-terracotta shrink-0 mt-1 mr-4" size={24} data-id="element-148" />
                  <p className="text-lg md:text-xl text-gray-700 font-medium" data-id="element-149">
                    {problem}
                  </p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-150">
            <div className="text-center space-y-6 pt-8 border-t border-warm-brown/20" data-id="element-151">
              <p className="text-xl md:text-2xl text-gray-600 italic" data-id="element-152">
                entonces sabes que el problema no es solo la comida.
              </p>
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-olive-green" data-id="element-153">
                El problema es el método.
              </h3>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-154">
                La mayoría de los planes fallan porque exigen demasiado
                sacrificio y muy poca sostenibilidad. Por eso este libro fue
                creado para ayudarte a comer de manera más inteligente, más rica
                y más realista.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}